// extracted by mini-css-extract-plugin
module.exports = {"container":"company-facts-section-module--container--1TGW6","fact":"company-facts-section-module--fact--2H425","title":"company-facts-section-module--title--3sT9y"};